'use client'
import { ContainerCustom, Icon } from '@/components'
import { CALLBACK_URL_KEY } from '@/constants'
import { BREAKPOINTS, HEADER_HEIGHT_PX } from '@/constants/layout'
import Link from '@/features/ref/components/Link'
import { usePathname } from '@/libs/i18n/routing'
import { useAccountStore } from '@/store'
import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { Fragment, useEffect, useState } from 'react'
import SlideText from './slide-text'

interface MenuItem {
  title: (t: (key: string, data?: Record<string, string>) => string) => string
  href: string
}

const LEFT_MENU_ITEMS: MenuItem[] = [
  // {
  //   title: (t: (key: string, data?: Record<string, string>) => string) => t('Về MONA', { name: 'HYDRA' }),
  //   href: '/about',
  // },
  {
    title: (t: (key: string) => string) => t('Blog'),
    href: '/blog',
  },
  {
    title: (t: (key: string) => string) => t('Liên hệ'),
    href: '/contact',
  },
]

export const TopBarV2 = () => {
  const t = useTranslations()
  const [isVisible, setIsVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const { isAuthenticated } = useAccountStore()
  const pathname = usePathname()

  const RIGHT_MENU_ITEMS = [
    {
      title: (t: (key: string) => string) => t('Thành viên'),
      href: '/accounts/membership/',
      isVisible: true,
    },
    // {
    //   title: (t: (key: string) => string) => t('Affiliate'),
    //   href: '/affiliate/dashboard',
    //   isVisible: isAuthenticated,
    // },
    {
      title: (t: (key: string) => string) => t('UserProfile.signin'),
      href: '/login?' + CALLBACK_URL_KEY + '=' + encodeURIComponent(pathname || '/'),
      isVisible: !isAuthenticated,
    },

    {
      title: (t: (key: string) => string) => t('UserProfile.signup'),
      href: '/register?' + CALLBACK_URL_KEY + '=' + encodeURIComponent(pathname || '/'),
      isVisible: !isAuthenticated,
    },
  ]
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      const width = window.innerWidth
      if (width > BREAKPOINTS.md) return
      // Chỉ ẩn/hiện khi scroll > 100px để tránh flickering
      if (currentScrollY > 100) {
        if (currentScrollY < lastScrollY) {
          // Scroll lên
          setIsVisible(true)
        } else {
          // Scroll xuống
          setIsVisible(false)
        }
      } else {
        // Luôn hiện khi ở gần đầu trang
        setIsVisible(true)
      }

      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollY, isVisible])
  return (
    <Box
      sx={{
        color: 'white',
        height: 'var(--size-hd-top)',
        display: 'flex',
        transition: 'height 0.3s ease',
        alignItems: 'center',
        backgroundColor: 'primary.main',
        position: 'relative',
        overflow: 'hidden',
        '& a': {
          color: 'inherit',
          textDecoration: 'none',
        },
      }}
    >
      <ContainerCustom component={'div'} sx={{ position: 'relative', zIndex: 1 }}>
        <Stack direction="row" gap={{ lg: 4, xs: 1 }} justifyContent={'space-between'} alignItems="center">
          {/* Left Menu */}
          <Stack
            direction="row"
            gap={{ lg: 2, xs: 1 }}
            sx={{ display: { xs: 'none', md: 'flex' } }}
            justifyContent={'center'}
            alignItems="center"
            whiteSpace={'nowrap'}
          >
            {LEFT_MENU_ITEMS.map((item, index, arr) => {
              return (
                <Fragment key={item.href}>
                  <Typography
                    component={'p'}
                    color="inherit"
                    sx={{
                      fontWeight: 600,
                      paddingY: '2px',
                      cursor: 'pointer',
                      transition: 'border-color 0.3s ease',
                      borderBottom: '1px solid transparent',
                      '&:hover': { borderColor: '#fff' },
                      fontSize: { xs: '0.75rem', lg: '0.875rem' },
                    }}
                  >
                    <Link href={item.href}>{item.title(t)}</Link>
                  </Typography>
                  {index !== arr.length - 1 && (
                    <Divider
                      orientation="vertical"
                      sx={{ borderColor: 'white', height: '12px', opacity: '0.2' }}
                    />
                  )}
                </Fragment>
              )
            })}
          </Stack>
          {/* Center Title */}
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              overflow: 'hidden',
              width: { xs: '100%', sm: '60%' },
            }}
          >
            <SlideText></SlideText>
          </Box>
          {/* Right Menu */}
          <Stack
            direction="row"
            gap={{ lg: 2, xs: 1 }}
            sx={{ display: { xs: 'none', md: 'flex' } }}
            justifyContent={'center'}
            alignItems="center"
            whiteSpace={'nowrap'}
          >
            {RIGHT_MENU_ITEMS.map((item, index, arr) => {
              if (item.isVisible === false) return null
              return (
                <Fragment key={item.href}>
                  <Typography
                    component={'p'}
                    color="inherit"
                    sx={{
                      fontWeight: 600,
                      paddingY: '2px',
                      cursor: 'pointer',
                      transition: 'border-color 0.3s ease',
                      borderBottom: '1px solid transparent',
                      '&:hover': { borderColor: '#fff' },
                      fontSize: { xs: '0.75rem', lg: '0.875rem' },
                    }}
                  >
                    <Link href={item.href}>{item.title(t)}</Link>
                  </Typography>

                  {index !== arr.length - 1 && !isAuthenticated && (
                    <Divider
                      orientation="vertical"
                      sx={{ borderColor: 'white', height: '12px', opacity: '0.2' }}
                    />
                  )}
                </Fragment>
              )
            })}
          </Stack>
          {/* <Box sx={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)' }}>
            <ThemeToggle size="small" />
          </Box> */}
        </Stack>
      </ContainerCustom>
    </Box>
  )
}
